import { WorkShopDTO } from './../../../shared/dto/work-shop.dto';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit, ViewChild, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { CoreService } from '../../../shared/service/app/core.service';
import { CommonService } from './../../../shared/service/common/common.service';
import moment from 'moment';
import { AssistantService } from '../../../../app/components/assistant/service/assistant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoordinatesDTO } from 'src/app/shared/dto/common.dto';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { NewChatDTO, NewMessageDTO } from './../../../shared/dto/message-chat.dto';
import { initialNewChat } from './../../../shared/constants/message.constants';
import { MatDialog } from '@angular/material/dialog';

const slideDownUp = trigger('slideDownUp', [
  state('void', style({ opacity: 0, transform: 'translateY(-20px)' })),
  state('*', style({ opacity: 1, transform: 'translateY(0)' })),
  transition('void => *', animate('200ms ease-in')),
  transition('* => void', animate('200ms ease-out')),
]);
@Component({
  selector: 'app-assistant-ai',
  templateUrl: './assistant-ai.component.html',
  styleUrl: './assistant-ai.component.css',
  animations: [slideDownUp],
})
export class AssistantAiComponent implements OnInit, AfterViewChecked {
  @ViewChild('scrollable') scrollable!: NgScrollbar;
  @Input() selectedService: string = '';
  @Output() workshopsFound = new EventEmitter<WorkShopDTO[]>();
  @Input() set selectedWorkshop(workshop: WorkShopDTO | null) {
    if (workshop) {
      this.handleSelectedWorkshop(workshop);
    }
  }

  fechaActual: string = moment().format('YYYY-MM-DD');
  isMobile: boolean = false;
  coordinates: CoordinatesDTO = { lat: 0, lng: 0 };
  isMapVisible: boolean = false;
  isSmallScreen: boolean = false;
  textMessage: string = '';
  loadingConversation: boolean = false;
  isExpanded: boolean = false;
  selectedAvatar: string | null = null;
  messages: NewMessageDTO[] = [];
  chatId: string = '';
  myIp: string = '';
  message: NewMessageDTO | undefined;
  ip: string = '';
  workShop: WorkShopDTO | null = null;
  isModalOpen: boolean = false;
  isDarkMode: boolean = false;

  currentChat: NewChatDTO | null = null;
  private shouldScrollToBottom: boolean = false;

  constructor(
    public store: Store<any>,
    public core: CoreService,
    public commonService: CommonService,
    private router: Router,
    private assistantService: AssistantService,
    private route: ActivatedRoute,
    private analytics: AnalitycsService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    this.store
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
        this.cdr.detectChanges();
      });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.selectedService = params['service'];
    });
    this.route.queryParams.subscribe((params) => {
      const lat = Number(params['lat']);
      const lng = Number(params['lng']);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.coordinates = { lat, lng };
      }
    });
    this.checkScreenSize();
    this.startConversation(0);
    this.selectedAvatar =
      localStorage.getItem('selectedAvatar') ?? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVCSMkWaF4ReLMfiRu3NXk12zJikhfSx0bSQ&s';
  }

  checkScreenSize(): void {
    const width = localStorage.getItem('screenWidth') ?? 0;
    this.isSmallScreen = Number(width) <= 900;
  }
  async startConversation(id: number) {
    this.analytics.logEvent('iniciando_conversacion_con_asistente', {
      pantalla: 'asistente-ai',
      accion: 'clic',
      plataforma: 'web',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });

    this.loadingConversation = true;
    try {
      localStorage.removeItem('sender');
      localStorage.removeItem('chat');

      const chatData = id === 0 ? localStorage.getItem('newChat') : null;
      this.ip = await this.commonService.getIPAddress();

      if (chatData) {
        const savedChat = JSON.parse(chatData);
        this.chatId = savedChat.id;
        this.currentChat = savedChat;

        if (savedChat.messages && savedChat.messages.length > 0) {
          this.messages = [];
          savedChat.messages.forEach((msg: NewMessageDTO) => {
            const uiMessage: NewMessageDTO = JSON.parse(JSON.stringify(initialNewChat));
            uiMessage.role = msg.role;
            uiMessage.content = msg.content;
            this.messages.push(uiMessage);
          });
        }
      } else {
        const newChat = this.buildNewChat();

        if (this.selectedService !== '' && this.selectedService !== undefined) {
          newChat.initial_message.content = `Necesito un Servicio de ${this.selectedService}`;
        }

        const response = await this.assistantService.createNewChat(newChat);
        this.chatId = response.id || '';
        this.currentChat = response;

        localStorage.setItem('newChat', JSON.stringify(response));

        if (response.messages && response.messages.length > 0) {
          this.messages = [];
          response.messages.forEach((msg: NewMessageDTO) => {
            const uiMessage: NewMessageDTO = JSON.parse(JSON.stringify(initialNewChat));
            uiMessage.role = msg.role;
            uiMessage.content = msg.content;
            this.messages.push(uiMessage);
          });
        }
      }
    } catch (error: any) {
      console.error('Error starting conversation:', error);
      const errorMessage: NewMessageDTO = JSON.parse(JSON.stringify(initialNewChat));
      errorMessage.role = 'user';
      errorMessage.content = 'Existe un error al contactar con el asistente, por favor intentelo de nuevo mas tarde.';
      this.messages.push(errorMessage);
    }
    this.loadingConversation = false;
    this.scrollToBottom();
  }

  private buildNewChat(message: string = ''): NewChatDTO {
    const newChat = JSON.parse(JSON.stringify(initialNewChat));
    newChat.title = '';
    newChat.initial_message.content = message || 'Hola ayudame a entender el problema con mi vehiculo';
    newChat.initial_message.metadata.source = 'fe-web';
    newChat.initial_message.metadata.userAgent = navigator.userAgent;
    newChat.initial_message.metadata.ip = this.ip;

    if (this.coordinates && this.coordinates.lat !== 0 && this.coordinates.lng !== 0) {
      newChat.metadata.gpsLocation.coordinates = [this.coordinates.lng, this.coordinates.lat];
    }

    return newChat;
  }

  async sendMessage() {
    this.analytics.logEvent('enviar_mensaje_al_asistente', {
      pantalla: 'asistente-ai',
      accion: 'clic',
      plataforma: 'web',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });

    try {
      if (this.textMessage.trim() === '') {
        return;
      }

      const tempMessage: NewMessageDTO = JSON.parse(JSON.stringify(initialNewChat));
      tempMessage.role = 'user';

      // Si es un mensaje para agendar cita, lo formateamos para la UI
      if (this.textMessage.includes('Quiero agendar una cita') && this.workShop) {
        tempMessage.content = this.formatAppointmentMessage(this.textMessage, this.workShop.companyName);
      } else {
        tempMessage.content = this.textMessage;
      }

      this.messages.push(tempMessage);
      this.shouldScrollToBottom = true;

      const messageToSend = {
        content: this.textMessage,
        role: 'user',
        conversation_id: this.chatId,
        ip: this.ip,
      };

      const userMessage = this.textMessage;
      this.textMessage = '';
      this.scrollToBottom();
      this.loadingConversation = true;

      if (userMessage.includes('Quiero agendar una cita') && this.workShop) {
        messageToSend.content += `${userMessage} (Ten en cuenta el worshop seleccionado workShopName=${this.workShop?.companyName}, workShopId=${this.workShop?._id}, workShopTuulAppId=${this.workShop?.idTuulapp})`;
      }

      let response: any = await this.assistantService.sendNewMessage(messageToSend);

      if (response.messages && response.messages.length > 0) {
        const lastMessage = response.messages[response.messages.length - 1];
        let newMessage = null;

        if (lastMessage.role === 'assistant' && lastMessage.content.includes('Un momento')) {
          newMessage = {
            content: '🚀 Estoy realizando el proceso....... ♻️',
            role: 'assistant',
            conversation_id: this.chatId,
            ip: this.ip,
          };
        } else if (
          lastMessage.role === 'assistant' &&
          (lastMessage.content.includes('debido a') || lastMessage.content.includes('deberse a') || lastMessage.content.includes('necesitas un servicio'))
        ) {
          newMessage = {
            content: '🚀 Muy bien, filtro los talleres del mapa y podrás identificar los que podrían ayudarte en tu problema. ♻️',
            role: 'assistant',
            conversation_id: this.chatId,
            ip: this.ip,
          };
        } else if (
          lastMessage.role === 'assistant' &&
          (lastMessage.content.includes('registrar la cita') || lastMessage.content.includes('Voy a proceder a registrar tu cita'))
        ) {
          newMessage = {
            content: '🚀 Muy bien, estoy registrando la cita. ♻️',
            role: 'assistant',
            conversation_id: this.chatId,
            ip: this.ip,
          };
        }

        if (newMessage) {
          response = await this.assistantService.sendNewMessage(newMessage);
          this.scrollToBottom();
        }
      }

      if (response.messages && response.messages.length > 0) {
        for (const message of response.messages) {
          if (message.role === 'tool') {
            if (message.content === 'searchWorkshop' && message.metadata && message.metadata.workshops) {
              this.workshopsFound.emit(message.metadata.workshops);
            }

            if (message.content === 'registerCite') {
              this.openRegistrationModal();
            }
          }
        }
      }

      this.currentChat = { ...response };

      localStorage.setItem('newChat', JSON.stringify(response));

      if (response.messages && response.messages.length > 0) {
        this.messages = [...response.messages];
      }

      this.scrollToBottom();
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMessage: NewMessageDTO = JSON.parse(JSON.stringify(initialNewChat));
      errorMessage.role = 'assistant';
      errorMessage.content = 'Existe un error al contactar con el asistente, por favor intentelo de nuevo mas tarde.';
      this.messages.push(errorMessage);
    }
    this.loadingConversation = false;
  }

  scrollToBottom(): void {
    this.shouldScrollToBottom = true;
    setTimeout(() => {
      try {
        if (this.scrollable) {
          this.scrollable.scrollTo({ bottom: 0, duration: 200 });
        }
      } catch (error) {
        console.error('Error scrolling to bottom:', error);
      }
    }, 100);
  }

  ngAfterViewChecked() {
    if (this.shouldScrollToBottom) {
      this.shouldScrollToBottom = false;
      try {
        if (this.scrollable) {
          this.scrollable.scrollTo({ bottom: 0, duration: 200 });
          this.cdr.detectChanges();
        }
      } catch (error) {
        console.error('Error in ngAfterViewChecked scrolling:', error);
      }
    }
  }

  assistantSchedule(workShop: WorkShopDTO | null) {
    this.analytics.logEvent('agendar_cita_con_taller', {
      pantalla: 'assistant-ai',
      accion: 'clic',
      plataforma: 'web',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.workShop = workShop!;
    this.textMessage = `Quiero agendar una cita en ${workShop!.companyName}`;
    this.sendMessage();
  }

  backToHome() {
    this.analytics.logEvent('regresar_a_home', {
      pantalla: 'assistant-ai',
      accion: 'clic',
      plataforma: 'web',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    if (this.coordinates.lat === 0 && this.coordinates.lng === 0) {
      this.router.navigate(['']);
    } else {
      this.router.navigate([''], { queryParams: { lat: this.coordinates.lat, lng: this.coordinates.lng } });
    }
  }

  toggleSize() {
    this.isExpanded = !this.isExpanded;
  }

  adjustTextareaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    const lineHeight = 24;
    const maxHeight = lineHeight * 2;
    const newHeight = Math.min(textarea.scrollHeight, maxHeight);
    textarea.style.height = `${newHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  handleSelectedWorkshop(workshop: WorkShopDTO) {
    this.workShop = workshop;
    this.textMessage = `Quiero agendar una cita en ${workshop.companyName}`;
    this.sendMessage();
    this.core.toggleToMap(false);
  }

  onModalClosed(event: boolean): void {
    console.log(event);
    this.isModalOpen = false;
  }

  openRegistrationModal(): void {
    const tkn = localStorage.getItem('secTkn');
    if (!tkn) {
      this.isModalOpen = true;
    }
  }

  /**
   * Formatea el mensaje de agendar cita para que se vea mejor en la interfaz de usuario
   * @param message El mensaje original
   * @param workshopName El nombre del taller
   * @returns El mensaje formateado para mostrar en la UI
   */
  formatAppointmentMessage(message: string, workshopName: string): string {
    // Truncamos completamente el mensaje y solo mostramos la parte esencial
    return `Quiero agendar una cita en <strong>${workshopName}</strong>`;
  }
}
